export default class ApiUrl {
    public static baseUrl: string = "https://api-gateway.touchpay.pro";
    // public static baseUrl: string = "http://localhost:8080/core";
}